<template>
  <div class="alert alert-info">
    <h3 class="mb-0">{{ $t("HALL_IS_MARKED_FOR_CLEANING") }}.</h3>
    <div class="d-flex align-items-center justify-content-between">
      <h4 v-if="['Admin', 'Manager'].includes(user.role)" class="mb-0">
        {{ $t("PLEASE_CONFIRM_THAT_THE_CLEANING_HAS_BEEN_PERFORMED") }}
      </h4>
      <button
        v-if="['Admin', 'Manager'].includes(user.role)"
        @click="cleanHall()"
        class="btn btn-block btn-danger"
      >
        {{ $t("CONFIRM") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      type: Object
    }
  },

  methods: {
    cleanHall() {
      this.$emit("clean-hall");
    }
  }
};
</script>

<style scoped>
.alert {
  display: block;
}

.btn {
  max-width: 300px;
}
</style>
